import { useCalendar } from "Components/Common/hooks/useCalendar";
import { useScheduleEntries } from "Components/ScheduleEntry/hooks/useScheduleEntries";
import { useMemo } from "react";
import { getVisibleMinutesEnd } from "../helpers/getVisibleMinutesEnd";
import { getVisibleMinutesStart } from "../helpers/getVisibleMinutesStart";
import { MinuteRange } from "../types/MinuteRange";

export function useVisibleMinutes(): MinuteRange {
	const startOfWeek = useCalendar((state) => state.startOfWeek);
	const weekPlus = useCalendar((state) => state.weekPlus);
	const workingMinutes = useCalendar((state) => state.workingMinutes);
	const scheduleEntries = useScheduleEntries((state) => state.items);
	const startTimes = scheduleEntries.map((schedule) => schedule.startTime);
	const endTimes = scheduleEntries.map((schedule) => schedule.endTime);
	const isFutureWeek = weekPlus >= 0;

	const start = useMemo(
		() =>
			getVisibleMinutesStart(workingMinutes, startOfWeek, startTimes, endTimes),
		[workingMinutes, startOfWeek, startTimes, endTimes]
	);

	const end = useMemo(
		() =>
			getVisibleMinutesEnd(workingMinutes, startOfWeek, startTimes, endTimes),
		[workingMinutes, startOfWeek, startTimes, endTimes]
	);

	return {
		start: isFutureWeek ? Math.min(workingMinutes.start, start) : start,
		end: isFutureWeek ? Math.max(workingMinutes.end, end) : end,
	};
}
